import { render } from "./AddProprietarioPage.vue?vue&type=template&id=f32d595c"
import script from "./AddProprietarioPage.vue?vue&type=script&lang=js"
export * from "./AddProprietarioPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__